import React from "react";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import AncillaryInput from "../../../components/NewsLetter/AncillaryInput";
import Layout from "../../../Layout";

const CreateAncillary = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Ancillary",
      route: "/website/masters/ancillary-details",
    },
    {
      title: "Add Newsletter",
      route: "/website/masters/ancillary-details/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Ancillary"}>
      <CustomHeaderTitle title={"Create Ancillary"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Ancillary"}
      ></HeaderBread>
      <AncillaryInput newsletter={{}} />
    </Layout>
  );
};

export default CreateAncillary;
